import { render, staticRenderFns } from "./SelectMembersChip.vue?vue&type=template&id=610ce8d0&scoped=true&"
import script from "./SelectMembersChip.vue?vue&type=script&lang=js&"
export * from "./SelectMembersChip.vue?vue&type=script&lang=js&"
import style0 from "./SelectMembersChip.vue?vue&type=style&index=0&id=610ce8d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610ce8d0",
  null
  
)

export default component.exports